/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeSyncEndpointResponse
 */
export interface TimeSyncEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof TimeSyncEndpointResponse
     */
    output: string;
}

export function TimeSyncEndpointResponseFromJSON(json: any): TimeSyncEndpointResponse {
    return TimeSyncEndpointResponseFromJSONTyped(json, false);
}

export function TimeSyncEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeSyncEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'output': json['output'],
    };
}

export function TimeSyncEndpointResponseToJSON(value?: TimeSyncEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'output': value.output,
    };
}


